import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import c from "./brandCategorySelector.ce.vue.js";
import { vCopyVueucStylesToShadowDom as s } from "../../utils/vCopyVueucStylesToShadowDom.js";
import { defineComponent as f, useTemplateRef as d, withDirectives as u, openBlock as C, createBlock as y, withCtx as l, createVNode as n } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as _ } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { unref as e } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import h from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import v from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/date/zhCN.js";
import g from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
import S from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/MessageProvider.js";
const z = /* @__PURE__ */ f({
  name: "BrandCategorySelectorEntry",
  __name: "index.ce",
  setup(R, { expose: i }) {
    const r = d("brandCategorySelectorRef"), t = _(), p = {
      common: {
        primaryColor: "#FC9153",
        primaryColorHover: "#FC9153",
        primaryColorPressed: "#FC9153",
        primaryColorSuppl: "#FC9153"
      }
    };
    return i({ open: (a) => {
      var o, m;
      return (m = (o = r.value) == null ? void 0 : o.open(a)) != null ? m : Promise.resolve([]);
    } }), (a, o) => u((C(), y(e(g), {
      locale: e(h),
      "date-locale": e(v),
      "theme-overrides": p,
      "style-mount-target": e(t)
    }, {
      default: l(() => [
        n(e(S), null, {
          default: l(() => [
            n(c, {
              ref_key: "brandCategorySelectorRef",
              ref: r
            }, null, 512)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["locale", "date-locale", "style-mount-target"])), [
      [e(s), e(t)]
    ]);
  }
});
export {
  z as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/brand-category-selector/index.ce.vue2.js
// module id = 1181
// module chunks = 41